import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";
import {
  getToken as getAppCheckToken,
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  type AppCheck
} from "firebase/app-check";
import { EXPECTED_FIREBASE_PROJECT, IS_MOCK } from "./runtime";

let firebaseApp: FirebaseApp | null = null;
let appCheck: AppCheck | null = null;

function getFirebaseApp(): FirebaseApp {
  if (firebaseApp) return firebaseApp;
  const config = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID
  };
  if (!config.apiKey || !config.authDomain || !config.appId || config.projectId !== EXPECTED_FIREBASE_PROJECT) {
    throw new Error(`The ${EXPECTED_FIREBASE_PROJECT} Firebase web configuration is incomplete`);
  }
  firebaseApp = initializeApp(config);
  const siteKey = import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY;
  if (!siteKey && !import.meta.env.DEV) {
    throw new Error("Firebase App Check is required for the admin portal");
  }
  if (siteKey) {
    appCheck = initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true
    });
  }
  return firebaseApp;
}

export function getFirebaseAuth(): Auth {
  return getAuth(getFirebaseApp());
}

export async function getPortalAppCheckToken(forceRefresh = false): Promise<string | null> {
  if (IS_MOCK) return null;
  getFirebaseApp();
  if (!appCheck) return null;
  return (await getAppCheckToken(appCheck, forceRefresh)).token;
}
